(function() {
var t = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (extraStyles, id, url) {
buf.push("<iframe" + (jade.attr("id", id, true, false)) + (jade.attr("src", url, true, false)) + (jade.attr("style", "width: 100%; height: 100%; overflow: hidden; " + (extraStyles) + "", true, false)) + " scrollbars=\"no\" allowtransparency=\"yes\"></iframe>");}.call(this,"extraStyles" in locals_for_with?locals_for_with.extraStyles:typeof extraStyles!=="undefined"?extraStyles:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"url" in locals_for_with?locals_for_with.url:typeof url!=="undefined"?url:undefined));;return buf.join("");
};
this.jade.templates || (this.jade.templates = {});
this.jade.templates['embeddedAppIframe'] = t;

if (typeof hubspot === 'object' && hubspot.define) {
hubspot.updateDependencies('jade.templates.embeddedAppIframe');
}
return t;
}).call(this);

